import * as yup from 'yup'

/**
 * Mirrors `InternalAccessUsersInviteDto`. The allowed email domain is backend config, so an
 * address outside it is refused there and shown as the error toast.
 */
export const inviteInternalUserFormValidator = yup.object({
  email: yup.string().trim().required('Email is required').email('Enter a valid email address'),
  roleId: yup.string().required('Select a role'),
})
